<div class="feature-list"
     [ngClass]="{
          'hs-min': compData?.container?.feature?.type === F_TYPES.SHORTSTAY,
          'es-min': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY,
          'ssp-min': compData?.container?.feature?.type === F_TYPES.SHORTSTAY_PACKAGE
        }"
>
  @switch (compData?.container?.component) {
    @case ('PropertyCardComponent') {
      <app-b2b-property-card
        [compData]="{
          container: compData?.container,
          loaded: loadedEvent,
          index: compData?.index
        }"
        [enableMapView]="enableMapView"
        (selectedPropertyEvent)="selectedPropertyEvent?.emit()"
      >
      </app-b2b-property-card>
    }
    @case ('DesktopPropertyCardComponent') {
      <app-b2b-desktop-property-card
        [compData]="{
          container: compData?.container,
          loaded: loadedEvent,
          index: compData?.index
        }"
      >
      </app-b2b-desktop-property-card>
    }
  }
</div>

<!--selectedWidget ==> {{ selectedWidget | json }}-->

<!--@if (selectedWidget) {
  @let minHeight = isDesktop ? selectedWidget?.desktopConfig?.height : selectedWidget?.mobileConfig?.height;
  <div class="sk-ht pb-15 child-2"
       [ngStyle]="{ 'min-height': minHeight }">
    @defer (on viewport) {
      @if (promotionContainers$ | async; as promotionContainers) {
        @if (promotionContainers?.length > 0) {
          @for (promotionContainer of promotionContainers; track promotionContainer; ) {
            @switch (promotionContainer?.component) {
              @case ('SliderComponent') {
                <div class="">
                  <app-b2b-sliders
                    [compData]="{ container: promotionContainer }">
                  </app-b2b-sliders>
                </div>
              }
              @case ('OverlayCardComponent') {
                <div class="">
                  <app-b2b-overlay-card
                    [compData]="{ container: promotionContainer }">
                  </app-b2b-overlay-card>
                </div>
              }
            }
          }
        }
      } @else {
        &lt;!&ndash; TODO loader &ndash;&gt;
        <ng-container *ngTemplateOutlet="skeletonTemp;
        context:{
        minHeight:minHeight,
        }"></ng-container>
      }
    } @placeholder (minimum 500ms) {
      &lt;!&ndash; TODO loader &ndash;&gt;
      <div>
        <ng-container *ngTemplateOutlet="skeletonTemp; context:{
        minHeight:minHeight,
        }"></ng-container>
      </div>
    }
  </div>
}-->

<!--
@if (compData?.container?.promotionalContainers?.length > 0) {
  <div class="promo-img" [ngClass]="{'mapView': enableMapView}">
    @for (pContainer of compData?.container?.promotionalContainers; track pContainer) {
      @if (pContainer && pContainer?.component === 'PromoComponent') {
        <app-desktop-promo
          [compData]="{
        container: pContainer
      }"
        ></app-desktop-promo>
      }
      @if (pContainer && pContainer?.component === 'OverlayCardComponent') {
        <app-b2b-overlay-card
          [compData]="{
        container: pContainer
      }"
        ></app-b2b-overlay-card>
      }
    }
  </div>
}
-->

<!--<ng-template #skeletonTemp let-minHeight="minHeight">
  &lt;!&ndash;minHeight ==> {{ minHeight }}&ndash;&gt;
  <div class="bgClr loading" [ngStyle]="{ 'height': minHeight }">
    &lt;!&ndash;<div class="titleBox loading"></div>
    <div class="descBox loading"></div>
    <div class="gridBox">
      <div class="box loading"></div>
      <div class="box loading mob-box"></div>
      <div class="box loading mob-box"></div>
    </div>&ndash;&gt;
  </div>
</ng-template>-->
